import {IDS} from '../improvement-action-id.constants';
import {TYPES} from "../improvement-action-type.constants";
import * as Actions from '../improvement.actions';
import * as AccAction from '../../accreditation.actions';
import {GRID_FETCH, GRID_RELOAD} from "../../../../common/grid/grid.constants";
import get from 'lodash/get';
import moment from "moment";
import {formatDate} from "../../../../common/utils/util.date";
import {DATE_FORMAT} from "../../../../common/utils/util.constants";
import watch from "redux-watch";
import pick from "lodash/pick";
import {TAB_SELECT} from "../../../../common/tabs/tabs.constants";
import find from "lodash/find";

class ImprovementStepController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $uiRouterGlobals,
                $filter,
                $timeout,
                $transitions,
                $mdDialog,
                Notifier,
                DocumentManager,
                EmployeeService,
                AuthService,
                FileActions,
                $scope) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$transitions = $transitions;
        this.$mdDialog = $mdDialog;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.EmployeeService = EmployeeService;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
        this.identifier = IDS.rcoImprovement;
        this.tabsState = this.$state.$current.parent.name;
        this.tabState = IDS.app_accreditation_scheme_improvement_step;
        this.$scope = $scope;
    }

    $onInit() {
        this.schemeCode = this.$stateParams.itemCode;
        const user = this.AuthService.getUser();
        this.userUuid = user.uuid;
        this.isAdmin = user.type === 'Administrator';

        this.unsubscribe = this.$ngRedux.connect(state => {
            const accDashboardLocationYear = state.accreditation.accDashboardLocationYear;
            const subModule = state.accreditation.rcoImprovement;
            const step = subModule.step;
            // this.maxDueDate = moment(`${maxYear}-01-01`).add(fiscalYearStart, 'months').subtract(1,'days').toDate();
            this.minDueDate = new Date();

            return {
                improvementAction: subModule.improvementAction,
                improvementSteps: get(subModule, `${IDS.improvementStepsGrid}.items`, []),
                step,
                stepDocument: subModule.stepDocument,
                // stepDialog: subModule.stepDialog,
                fiscalYear: accDashboardLocationYear.year,
                alsoAssignImprovementAction: subModule.alsoAssignImprovementAction,
                isStepTaskLinkedToEvidence: !!subModule.step.evidence_id,
                isTaskCompleted: step.original_status_code === 'cpl',
                firstDocType: state.accreditation.common.documentTypes[0].value,
            }
        }, {
            ...AccAction,
            ...Actions,
            ...this.FileActions,
        })(this);

        const ctrl = this;
        this.$timeout(function() {
            ctrl.$ngRedux.dispatch({
                id: ctrl.identifier,
                type: TYPES.RESET_NEW_STEP_DETAILS,
            });
        }, 200);
    }

    async onAutocompleteKeywordQuery (keyword) {
        return await this.fetchEmployeesAndManagers(
            keyword,
            this.improvementAction.location_uuid,
            `${this.identifier}.${IDS.stepAssigneeCandidates}`,
        );
    }

    onUploadSave(event,ctrl) {
        if(!this.selectedDocumentUuid){

            const form = this.$scope.addNewDocumentForm;
            if(form.$invalid) {
                this.Notifier.error('Please fill in the form fields');
                return;
            }
        }
        const {step, stepDocument, selectedDocumentUuid, improvementAction} = this;

        this.addDocumentVersion({
            ard_id:     step.evidence_id,
            vdo_uuid:   selectedDocumentUuid,
            slo_uuid:   improvementAction.location_uuid,
            file_path:  event[0].filePath,
            doc_version:selectedDocumentUuid? undefined : stepDocument.doc_new_version || 1, // if new version is not specified, default to 1
            name:       selectedDocumentUuid? undefined : stepDocument.name,
            doc_num:    selectedDocumentUuid? undefined : stepDocument.doc_num,
            doc_type:   stepDocument.doc_type,
        }).then(({params}) =>{
            this.onCancelUpdateButton();
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.rcoEvidenceGroupDocumentsGrid
            });
        })
    }

    onUpdateGridButton({item}) {
        this.selectedDocumentUuid = item.id;
        this.selectedDocumentName = item.name;
        this.updateUploadPanel();
    }

    onRemoveGridButton({item}) {
        const {step, improvementAction} = this;
        this.removeDocumentFromEvidenceGroup({
            vdo_uuid:       item.id,
            evg_id:         step.evidence_id,
            requirement_id: step.requirement_id,
            slo_uuid:       improvementAction.location_uuid,
        }).then(() => {
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.rcoEvidenceGroupDocumentsGrid
            });
        });
    }

    onCancelUpdateButton() {
        this.selectedDocumentUuid = null;
        this.selectedDocumentName = null;
        this.updateUploadPanel();
    }

    updateUploadPanel() {
        this.hideNewDocDetails = this.isDocumentGeneratable || !!this.selectedDocumentUuid;
        this.uploadButtonLabel = this.$filter('translate')(`COMMON.BUTTON.${this.selectedDocumentUuid ? 'UPLOAD_NEW_VERSION' : 'ADD_DOCUMENT'}`);
    }

    onSubmit() {
        const form = this.$scope.stepForm
        // if (form.$invalid) {
        //     this.Notifier.error('COMMON.FIELDS_REQUIRED');
        //     for (const item of form.$$controls) {
        //         if (item.$invalid) {
        //             item.$setTouched();
        //         }
        //     }
        //     return;
        // }
        // if(!this.improvementSteps?.length) {
        //     this.Notifier.error('Please add at least one task');
        //     return;
        // }
        if (form.$invalid) {
            $scope.Notifier.error('COMMON.FIELDS_REQUIRED');
            form.improvementStepRejectionComment?.$setTouched();
            return;
        }
        const {step} = this;
        this.updateImprovementActionStep({
            task_id:        step.task_id,
            assignee_uuid:  step.assignee.subject_uuid,
            title:          step.title,
            description:    step.description,
            due_date:       step.due_date,
            status_code:    step.status_code !== step.original_status_code
                ? step.status_code
                : undefined,
            rejection_comment: step.status_code === 'pen'
                ? step.newRejectionComment
                : undefined,
        }).then(response => {
            step.rejection_comment = step.newRejectionComment || step.rejection_comment;
            step.original_status_code = step.status_code;
            this.$ngRedux.dispatch({
               type: TYPES.SELECT_STEP,
                details: step,
                firstDocType: this.firstDocType,
            });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.improvementStepsGrid,
            });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.improvementActionsGrid,
            })
        });
    }

    onCancel() {
        this.$ngRedux.dispatch({
            type: TAB_SELECT,
            id: IDS.app_accreditation_scheme_improvement,
            state: IDS.app_accreditation_scheme_improvement_list,
        });
    }

    $onDestroy() {
        if(this.unsubscribe)
            this.unsubscribe();
    }
}

ImprovementStepController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$uiRouterGlobals',
    '$filter',
    '$timeout',
    '$transitions',
    '$mdDialog',
    'Notifier',
    'DocumentManager',
    'EmployeeService',
    'AuthService',
    'FileActions',
    '$scope']

export const improvementStep = {
    controller: ImprovementStepController,
    template: require('./step.html')
}
